import { render, staticRenderFns } from "./ChangeLogs.vue?vue&type=template&id=10520cce&"
import script from "./ChangeLogs.vue?vue&type=script&lang=js&"
export * from "./ChangeLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports